import React from 'react';
import './TelegramStar.css';

interface TelegramStarProps {
  size?: number;
  animated?: boolean;
}

const TelegramStar: React.FC<TelegramStarProps> = ({ size = 20, animated = false }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`telegram-star ${animated ? 'telegram-star--animated' : ''}`}
    >
      <defs>
        <linearGradient id="starGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFC107" />
          <stop offset="50%" stopColor="#FFD54F" />
          <stop offset="100%" stopColor="#FFA000" />
        </linearGradient>
        <filter id="starGlow">
          <feGaussianBlur stdDeviation="0.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path
        d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20.02L12 16.77L7.09 20.02L8.45 13.97L4 9.27L9.91 8.26L12 2Z"
        fill="url(#starGradient)"
        filter="url(#starGlow)"
      />
    </svg>
  );
};

export default TelegramStar;

